// Placeholder product images using placehold.co
const ELECTRONICS_IMAGES = [
    'https://placehold.co/400x400/1e293b/e2e8f0?text=Wireless+Headphones',
    'https://placehold.co/400x400/1e293b/e2e8f0?text=Smart+Watch',
    'https://placehold.co/400x400/1e293b/e2e8f0?text=Bluetooth+Speaker',
    'https://placehold.co/400x400/1e293b/e2e8f0?text=Power+Bank',
    'https://placehold.co/400x400/1e293b/e2e8f0?text=USB+Hub',
    'https://placehold.co/400x400/1e293b/e2e8f0?text=Wireless+Charger',
    'https://placehold.co/400x400/1e293b/e2e8f0?text=Keyboard',
    'https://placehold.co/400x400/1e293b/e2e8f0?text=Mouse',
    'https://placehold.co/400x400/1e293b/e2e8f0?text=Monitor+Stand',
    'https://placehold.co/400x400/1e293b/e2e8f0?text=Webcam',
    'https://placehold.co/400x400/1e293b/e2e8f0?text=LED+Lamp',
    'https://placehold.co/400x400/1e293b/e2e8f0?text=Cable+Organizer',
];

const POTS_IMAGES = [
    'https://placehold.co/400x400/92400e/fef3c7?text=Ceramic+Pot',
    'https://placehold.co/400x400/92400e/fef3c7?text=Terracotta+Pot',
    'https://placehold.co/400x400/92400e/fef3c7?text=Hanging+Planter',
    'https://placehold.co/400x400/92400e/fef3c7?text=Modern+Planter',
    'https://placehold.co/400x400/92400e/fef3c7?text=Self+Watering+Pot',
    'https://placehold.co/400x400/92400e/fef3c7?text=Concrete+Pot',
    'https://placehold.co/400x400/92400e/fef3c7?text=Glass+Vase',
    'https://placehold.co/400x400/92400e/fef3c7?text=Bamboo+Planter',
    'https://placehold.co/400x400/92400e/fef3c7?text=Wooden+Box',
    'https://placehold.co/400x400/92400e/fef3c7?text=Metal+Stand',
    'https://placehold.co/400x400/92400e/fef3c7?text=Macrame+Hanger',
    'https://placehold.co/400x400/92400e/fef3c7?text=Tall+Planter',
];

const PLANTS_IMAGES = [
    'https://placehold.co/400x400/166534/dcfce7?text=Monstera',
    'https://placehold.co/400x400/166534/dcfce7?text=Snake+Plant',
    'https://placehold.co/400x400/166534/dcfce7?text=Fiddle+Leaf',
    'https://placehold.co/400x400/166534/dcfce7?text=Pothos',
    'https://placehold.co/400x400/166534/dcfce7?text=Peace+Lily',
    'https://placehold.co/400x400/166534/dcfce7?text=Spider+Plant',
    'https://placehold.co/400x400/166534/dcfce7?text=Rubber+Plant',
    'https://placehold.co/400x400/166534/dcfce7?text=ZZ+Plant',
    'https://placehold.co/400x400/166534/dcfce7?text=Aloe+Vera',
    'https://placehold.co/400x400/166534/dcfce7?text=Succulent+Set',
    'https://placehold.co/400x400/166534/dcfce7?text=Cactus',
    'https://placehold.co/400x400/166534/dcfce7?text=Boston+Fern',
];

const products = [
    // Electronics (1-12)
    {
        id: 1,
        name: 'Premium Wireless Headphones',
        category: 'electronics',
        image: ELECTRONICS_IMAGES[0],
        images: [ELECTRONICS_IMAGES[0]],
        new_price: 129.99,
        old_price: 179.99,
        description: 'High-quality wireless headphones with active noise cancellation, premium sound quality, and 30-hour battery life. Perfect for music lovers and professionals.',
        rating: 4.8,
        reviews: 245,
        inStock: true,
        tags: ['bestseller', 'new'],
    },
    {
        id: 2,
        name: 'Smart Fitness Watch Pro',
        category: 'electronics',
        image: ELECTRONICS_IMAGES[1],
        images: [ELECTRONICS_IMAGES[1]],
        new_price: 199.99,
        old_price: 249.99,
        description: 'Advanced fitness tracker with heart rate monitoring, GPS, sleep tracking, and 7-day battery life. Water resistant up to 50 meters.',
        rating: 4.6,
        reviews: 189,
        inStock: true,
        tags: ['popular'],
    },
    {
        id: 3,
        name: 'Portable Bluetooth Speaker',
        category: 'electronics',
        image: ELECTRONICS_IMAGES[2],
        images: [ELECTRONICS_IMAGES[2]],
        new_price: 79.99,
        old_price: 99.99,
        description: '360-degree stereo sound with deep bass. Waterproof design, 20-hour playtime, and built-in microphone for calls.',
        rating: 4.5,
        reviews: 312,
        inStock: true,
        tags: ['bestseller'],
    },
    {
        id: 4,
        name: '20000mAh Power Bank',
        category: 'electronics',
        image: ELECTRONICS_IMAGES[3],
        images: [ELECTRONICS_IMAGES[3]],
        new_price: 49.99,
        old_price: 69.99,
        description: 'Fast charging power bank with dual USB-C ports. Charge your devices up to 5 times. LED display shows remaining power.',
        rating: 4.7,
        reviews: 428,
        inStock: true,
        tags: ['bestseller'],
    },
    {
        id: 5,
        name: '7-in-1 USB-C Hub',
        category: 'electronics',
        image: ELECTRONICS_IMAGES[4],
        images: [ELECTRONICS_IMAGES[4]],
        new_price: 45.99,
        old_price: 59.99,
        description: 'Expand your laptop connectivity with HDMI 4K, USB 3.0 ports, SD card reader, and 100W power delivery pass-through.',
        rating: 4.4,
        reviews: 156,
        inStock: true,
        tags: ['new'],
    },
    {
        id: 6,
        name: 'Fast Wireless Charger',
        category: 'electronics',
        image: ELECTRONICS_IMAGES[5],
        images: [ELECTRONICS_IMAGES[5]],
        new_price: 34.99,
        old_price: 49.99,
        description: '15W fast wireless charging pad compatible with all Qi-enabled devices. Sleek design with LED indicator.',
        rating: 4.3,
        reviews: 198,
        inStock: true,
        tags: [],
    },
    {
        id: 7,
        name: 'Mechanical RGB Keyboard',
        category: 'electronics',
        image: ELECTRONICS_IMAGES[6],
        images: [ELECTRONICS_IMAGES[6]],
        new_price: 89.99,
        old_price: 119.99,
        description: 'Premium mechanical keyboard with customizable RGB backlighting, hot-swappable switches, and ergonomic design.',
        rating: 4.6,
        reviews: 267,
        inStock: true,
        tags: ['popular'],
    },
    {
        id: 8,
        name: 'Ergonomic Wireless Mouse',
        category: 'electronics',
        image: ELECTRONICS_IMAGES[7],
        images: [ELECTRONICS_IMAGES[7]],
        new_price: 59.99,
        old_price: 79.99,
        description: 'Comfortable ergonomic design with adjustable DPI, silent clicks, and long battery life. Works on any surface.',
        rating: 4.5,
        reviews: 143,
        inStock: true,
        tags: [],
    },
    {
        id: 9,
        name: 'Adjustable Monitor Stand',
        category: 'electronics',
        image: ELECTRONICS_IMAGES[8],
        images: [ELECTRONICS_IMAGES[8]],
        new_price: 69.99,
        old_price: 89.99,
        description: 'Aluminum monitor stand with USB 3.0 ports, drawer storage, and height adjustment. Supports up to 32" monitors.',
        rating: 4.4,
        reviews: 89,
        inStock: true,
        tags: [],
    },
    {
        id: 10,
        name: '4K HD Webcam',
        category: 'electronics',
        image: ELECTRONICS_IMAGES[9],
        images: [ELECTRONICS_IMAGES[9]],
        new_price: 99.99,
        old_price: 139.99,
        description: 'Professional 4K webcam with auto-focus, noise-canceling microphone, and low-light correction. Perfect for streaming and meetings.',
        rating: 4.7,
        reviews: 178,
        inStock: true,
        tags: ['new'],
    },
    {
        id: 11,
        name: 'Smart LED Desk Lamp',
        category: 'electronics',
        image: ELECTRONICS_IMAGES[10],
        images: [ELECTRONICS_IMAGES[10]],
        new_price: 54.99,
        old_price: 74.99,
        description: 'Touch-controlled LED lamp with wireless charging base, adjustable brightness, and color temperature. Eye-care technology.',
        rating: 4.5,
        reviews: 112,
        inStock: true,
        tags: [],
    },
    {
        id: 12,
        name: 'Premium Cable Organizer Kit',
        category: 'electronics',
        image: ELECTRONICS_IMAGES[11],
        images: [ELECTRONICS_IMAGES[11]],
        new_price: 24.99,
        old_price: 34.99,
        description: 'Complete cable management solution with clips, ties, and under-desk tray. Keep your workspace clean and organized.',
        rating: 4.2,
        reviews: 234,
        inStock: true,
        tags: [],
    },

    // Pots (13-24)
    {
        id: 13,
        name: 'Handcrafted Ceramic Planter',
        category: 'pots',
        image: POTS_IMAGES[0],
        images: [POTS_IMAGES[0]],
        new_price: 34.99,
        old_price: 44.99,
        description: 'Beautiful handmade ceramic pot with drainage hole and saucer. Glazed finish in modern matte colors. Perfect for medium plants.',
        rating: 4.8,
        reviews: 156,
        inStock: true,
        tags: ['bestseller'],
    },
    {
        id: 14,
        name: 'Classic Terracotta Pot Set',
        category: 'pots',
        image: POTS_IMAGES[1],
        images: [POTS_IMAGES[1]],
        new_price: 29.99,
        old_price: 39.99,
        description: 'Set of 3 traditional terracotta pots in graduated sizes. Excellent drainage and breathability for healthy plant roots.',
        rating: 4.6,
        reviews: 203,
        inStock: true,
        tags: ['popular'],
    },
    {
        id: 15,
        name: 'Macrame Hanging Planter',
        category: 'pots',
        image: POTS_IMAGES[2],
        images: [POTS_IMAGES[2]],
        new_price: 24.99,
        old_price: 34.99,
        description: 'Bohemian-style macrame plant hanger with ceramic pot included. Handwoven cotton rope, adjustable length. Perfect for trailing plants.',
        rating: 4.7,
        reviews: 178,
        inStock: true,
        tags: ['new'],
    },
    {
        id: 16,
        name: 'Modern Geometric Planter',
        category: 'pots',
        image: POTS_IMAGES[3],
        images: [POTS_IMAGES[3]],
        new_price: 42.99,
        old_price: 54.99,
        description: 'Contemporary geometric design pot with matte finish. Includes bamboo stand. Available in white, black, and sage green.',
        rating: 4.5,
        reviews: 134,
        inStock: true,
        tags: ['popular'],
    },
    {
        id: 17,
        name: 'Self-Watering Smart Pot',
        category: 'pots',
        image: POTS_IMAGES[4],
        images: [POTS_IMAGES[4]],
        new_price: 38.99,
        old_price: 49.99,
        description: 'Innovative self-watering system keeps plants hydrated for up to 2 weeks. Water level indicator included. Perfect for busy plant parents.',
        rating: 4.6,
        reviews: 189,
        inStock: true,
        tags: ['bestseller'],
    },
    {
        id: 18,
        name: 'Minimalist Concrete Planter',
        category: 'pots',
        image: POTS_IMAGES[5],
        images: [POTS_IMAGES[5]],
        new_price: 27.99,
        old_price: 35.99,
        description: 'Industrial-chic concrete pot with smooth finish. Lightweight yet durable. Drainage hole with cork plug included.',
        rating: 4.4,
        reviews: 98,
        inStock: true,
        tags: [],
    },
    {
        id: 19,
        name: 'Elegant Glass Terrarium',
        category: 'pots',
        image: POTS_IMAGES[6],
        images: [POTS_IMAGES[6]],
        new_price: 45.99,
        old_price: 59.99,
        description: 'Geometric glass terrarium for succulents and air plants. Gold-finished metal frame. Creates stunning centerpiece.',
        rating: 4.7,
        reviews: 145,
        inStock: true,
        tags: ['new'],
    },
    {
        id: 20,
        name: 'Natural Bamboo Planter Box',
        category: 'pots',
        image: POTS_IMAGES[7],
        images: [POTS_IMAGES[7]],
        new_price: 32.99,
        old_price: 42.99,
        description: 'Sustainable bamboo rectangular planter with removable liner. Perfect for herbs or small plants on windowsill.',
        rating: 4.3,
        reviews: 112,
        inStock: true,
        tags: [],
    },
    {
        id: 21,
        name: 'Rustic Wooden Plant Box',
        category: 'pots',
        image: POTS_IMAGES[8],
        images: [POTS_IMAGES[8]],
        new_price: 28.99,
        old_price: 36.99,
        description: 'Reclaimed wood planter with distressed finish. Waterproof liner included. Adds farmhouse charm to any space.',
        rating: 4.5,
        reviews: 87,
        inStock: true,
        tags: [],
    },
    {
        id: 22,
        name: 'Mid-Century Metal Plant Stand',
        category: 'pots',
        image: POTS_IMAGES[9],
        images: [POTS_IMAGES[9]],
        new_price: 54.99,
        old_price: 69.99,
        description: 'Retro-inspired metal plant stand in gold or black finish. Adjustable height. Holds pots up to 12 inches.',
        rating: 4.6,
        reviews: 167,
        inStock: true,
        tags: ['popular'],
    },
    {
        id: 23,
        name: 'Boho Macrame Wall Hanger',
        category: 'pots',
        image: POTS_IMAGES[10],
        images: [POTS_IMAGES[10]],
        new_price: 19.99,
        old_price: 27.99,
        description: 'Wall-mounted macrame plant holder with decorative beads. Holds small to medium pots. Bohemian aesthetic.',
        rating: 4.4,
        reviews: 134,
        inStock: true,
        tags: [],
    },
    {
        id: 24,
        name: 'Tall Floor Standing Planter',
        category: 'pots',
        image: POTS_IMAGES[11],
        images: [POTS_IMAGES[11]],
        new_price: 79.99,
        old_price: 99.99,
        description: 'Statement floor planter for large plants. Fiberglass construction, lightweight yet durable. Modern tapered design.',
        rating: 4.7,
        reviews: 78,
        inStock: true,
        tags: ['new'],
    },

    // Plants (25-36)
    {
        id: 25,
        name: 'Monstera Deliciosa',
        category: 'plants',
        image: PLANTS_IMAGES[0],
        images: [PLANTS_IMAGES[0]],
        new_price: 45.99,
        old_price: 59.99,
        description: 'The iconic Swiss cheese plant with stunning split leaves. Low maintenance, thrives in indirect light. 12" pot included.',
        rating: 4.9,
        reviews: 312,
        inStock: true,
        tags: ['bestseller', 'popular'],
    },
    {
        id: 26,
        name: 'Snake Plant (Sansevieria)',
        category: 'plants',
        image: PLANTS_IMAGES[1],
        images: [PLANTS_IMAGES[1]],
        new_price: 32.99,
        old_price: 42.99,
        description: 'Nearly indestructible air-purifying plant. Tolerates low light and irregular watering. NASA-approved for clean air.',
        rating: 4.8,
        reviews: 456,
        inStock: true,
        tags: ['bestseller'],
    },
    {
        id: 27,
        name: 'Fiddle Leaf Fig',
        category: 'plants',
        image: PLANTS_IMAGES[2],
        images: [PLANTS_IMAGES[2]],
        new_price: 68.99,
        old_price: 89.99,
        description: 'Dramatic statement plant with large violin-shaped leaves. Loves bright indirect light. Comes in decorative pot.',
        rating: 4.5,
        reviews: 234,
        inStock: true,
        tags: ['popular'],
    },
    {
        id: 28,
        name: 'Golden Pothos',
        category: 'plants',
        image: PLANTS_IMAGES[3],
        images: [PLANTS_IMAGES[3]],
        new_price: 18.99,
        old_price: 24.99,
        description: 'Easy-care trailing vine with heart-shaped leaves. Perfect for hanging baskets or shelves. Grows quickly in any light.',
        rating: 4.7,
        reviews: 389,
        inStock: true,
        tags: ['bestseller'],
    },
    {
        id: 29,
        name: 'Peace Lily',
        category: 'plants',
        image: PLANTS_IMAGES[4],
        images: [PLANTS_IMAGES[4]],
        new_price: 28.99,
        old_price: 36.99,
        description: 'Elegant flowering plant with white spathes. Excellent air purifier. Thrives in low to medium light conditions.',
        rating: 4.6,
        reviews: 267,
        inStock: true,
        tags: ['popular'],
    },
    {
        id: 30,
        name: 'Spider Plant',
        category: 'plants',
        image: PLANTS_IMAGES[5],
        images: [PLANTS_IMAGES[5]],
        new_price: 16.99,
        old_price: 22.99,
        description: 'Classic houseplant with arching green and white striped leaves. Produces baby plants. Very adaptable and resilient.',
        rating: 4.5,
        reviews: 198,
        inStock: true,
        tags: [],
    },
    {
        id: 31,
        name: 'Rubber Plant (Ficus Elastica)',
        category: 'plants',
        image: PLANTS_IMAGES[6],
        images: [PLANTS_IMAGES[6]],
        new_price: 38.99,
        old_price: 49.99,
        description: 'Bold plant with large glossy burgundy leaves. Easy to care for, grows tall. Makes excellent focal point.',
        rating: 4.6,
        reviews: 156,
        inStock: true,
        tags: ['new'],
    },
    {
        id: 32,
        name: 'ZZ Plant',
        category: 'plants',
        image: PLANTS_IMAGES[7],
        images: [PLANTS_IMAGES[7]],
        new_price: 35.99,
        old_price: 45.99,
        description: 'Ultra-low maintenance with waxy dark green leaves. Tolerates neglect, low light, and drought. Perfect for beginners.',
        rating: 4.8,
        reviews: 289,
        inStock: true,
        tags: ['bestseller'],
    },
    {
        id: 33,
        name: 'Aloe Vera',
        category: 'plants',
        image: PLANTS_IMAGES[8],
        images: [PLANTS_IMAGES[8]],
        new_price: 19.99,
        old_price: 26.99,
        description: 'Medicinal succulent with soothing gel. Easy to care for, needs minimal water. Great for sunny windowsills.',
        rating: 4.7,
        reviews: 345,
        inStock: true,
        tags: ['popular'],
    },
    {
        id: 34,
        name: 'Succulent Variety Set (6 Pack)',
        category: 'plants',
        image: PLANTS_IMAGES[9],
        images: [PLANTS_IMAGES[9]],
        new_price: 34.99,
        old_price: 44.99,
        description: 'Curated collection of 6 unique succulents. Low maintenance, drought-tolerant. Perfect for terrariums and arrangements.',
        rating: 4.6,
        reviews: 423,
        inStock: true,
        tags: ['bestseller'],
    },
    {
        id: 35,
        name: 'Mini Cactus Collection',
        category: 'plants',
        image: PLANTS_IMAGES[10],
        images: [PLANTS_IMAGES[10]],
        new_price: 22.99,
        old_price: 29.99,
        description: 'Set of 4 adorable mini cacti in ceramic pots. Minimal watering needed. Perfect desk or shelf decoration.',
        rating: 4.4,
        reviews: 178,
        inStock: true,
        tags: [],
    },
    {
        id: 36,
        name: 'Boston Fern',
        category: 'plants',
        image: PLANTS_IMAGES[11],
        images: [PLANTS_IMAGES[11]],
        new_price: 26.99,
        old_price: 34.99,
        description: 'Lush cascading fern with feathery fronds. Loves humidity and indirect light. Perfect for hanging baskets.',
        rating: 4.5,
        reviews: 145,
        inStock: true,
        tags: ['new'],
    },
];

export default products;

// Helper function to get featured products (bestsellers and popular)
export const getFeaturedProducts = () => {
    return products.filter(
        (product) => product.tags.includes('bestseller') || product.tags.includes('popular')
    ).slice(0, 8);
};

// Helper function to get new arrivals
export const getNewArrivals = () => {
    return products.filter((product) => product.tags.includes('new'));
};

// Helper function to get products by category
export const getProductsByCategory = (category) => {
    return products.filter((product) => product.category === category);
};

// Helper function to get product by ID
export const getProductById = (id) => {
    return products.find((product) => product.id === id);
};
